import { helper } from '@ember/component/helper';

const recordModel = 'catalog-record';
const itemModel = 'item';
const modelRunModel = 'model-run';

const catalogRoute = 'catalog';
const recordRoute = catalogRoute + '.record';
const itemRoute = recordRoute + '.item';

const itemRecordId = 'catalogRecord.id';
const itemId = 'id';
const modelRunRecordId = 'item.' + itemRecordId;
const modelRunItemId = 'item.' + itemId;

export default helper(function linkToItemHelper([ model ]) {
  let result = [ catalogRoute ];
  let modelName = model?.constructor?.modelName;
  if (!modelName) {
    return result;
  }
  if (modelName === itemModel) {
    result[0] = itemRoute;
    result.push(model.get(itemRecordId), model.get(itemId));
  } else if (modelName === modelRunModel) {
    result[0] = itemRoute;
    result.push(model.get(modelRunRecordId), model.get(modelRunItemId));
  }
  if (modelName === recordModel) {
    result[0] = recordRoute;
    result.push(model.id);
  }
  return result;
});
